import React from "react";

import InputError from "components/InputsField/InputError";
import Error from "components/Forms/Error";

export const getErrorFieldsFromResponse = (response) => {
    let arr = [];
    if (response && response.status === 400 && response.data && response.data.errors) {
        arr = response.data.errors.map((el) => el.context.label);
    }
    return arr;
};

export const errorMessageCollect = (arr) => {
    return (
        arr &&
        arr.reduce((obj, el) => {
            let errorType = "Некорректное значение";
            if (el.type === "any.required") {
                errorType = "Обязательное поле";
            }
            if (el.type === "number.base" || el.type === "number.unsafe") {
                errorType = "";
            }

            if (
                el.path[0] === "intensity_from" ||
                el.path[0] === "intensity_to" ||
                el.path[0] === "common_volume"
            ) {
                obj[el.path[0]] = <InputError message={""} mode={"center"} />;
            } else if (el.path[0] === "transports") {
                obj[el.path[0]] = (
                    <InputError
                        message={
                            errorType === "Обязательное поле"
                                ? "Обязательные поля. Добавьте хотя бы один транспорт и маршрут"
                                : "Некорректное значение поля"
                        }
                        mode={"top-left"}
                    />
                );
            } else if (el.type === "number.base" || el.type === "number.unsafe") {
                obj[el.path[0]] = <InputError message={errorType} mode={"center"} />;
            } else {
                obj[el.path[0]] = <InputError message={errorType} mode={"bottom-left"} />;
            }

            return obj;
        }, {})
    );
};

export const errorToRender = (error, t) => {
    if (error && error.status) {
        if (error.status === 400) {
            return <Error>{t("errors.mainFormError")}</Error>;
        } else if (error.status === 500 || error.status === 503) {
            return <Error>{t("errors.serverError")}</Error>;
        }
    }
    return "";
};
